export const LOGINMODUL_LOGOUT_PENGGUNA = "LOGINMODUL_LOGOUT_PENGGUNA";
export const LOGINMODUL_LOGOUT_REQUEST = "LOGINMODUL_LOGOUT_REQUEST";
export const LOGINMODUL_LOGOUT_SUCCESS = "LOGINMODUL_LOGOUT_SUCCESS";
export const LOGINMODUL_LOGOUT_FAIL = "LOGINMODUL_LOGOUT_FAIL";
export const LOGINMODUL_LOGOUT_RESET = "LOGINMODUL_LOGOUT_SUCCESS";
